export default __webpack_public_path__ + "static/media/trusted_bakers_choices1.50a6bd2b.png";